import DynamicLinkContent from '../../../../components/DynamicLinkContent';
import { METHODFI_PRIVACY_POLICY_URL, METHODFI_TERMS_URL } from '../../../../constants/urls';

type MethodFiConsentCopyProps = {
  consentText: string;
};

const MethodFiConsentCopy = ({ consentText }: MethodFiConsentCopyProps) => (
  <DynamicLinkContent
    content={consentText}
    dynamicContentHandlers={[
      {
        content: 'Privacy Policy',
        onClick: () => {
          window.open(METHODFI_PRIVACY_POLICY_URL, '_blank', 'noopener,noreferrer');
        },
        trackClick: 'open_methodfi_privacy_policy',
      },
      {
        content: 'Terms of Service',
        onClick: () => {
          window.open(METHODFI_TERMS_URL, '_blank', 'noopener,noreferrer');
        },
        trackClick: 'open_methodfi_terms_of_service',
      },
    ]}
    fontSize="xs"
    color="gray.500"
    textAlign="left"
    handlerProps={{ fontSize: 'xs' }}
  />
);

export default MethodFiConsentCopy;
